// Generated from api/openapi/operations.yaml by make docs. Do not edit.
import { z } from "zod";

export const passkeyOverviewSchema = z.object({
  "users_with_passkey": z.number().int().min(0),
  "users_total": z.number().int().min(0),
  "passkeys_added_30d": z.number().int().min(0),
  "passkeys_revoked_30d": z.number().int().min(0),
  "passkey_logins_30d": z.number().int().min(0),
  "fallback_logins_30d": z.number().int().min(0),
  "avg_passkeys_per_user": z.number().min(0),
  "authenticator_breakdown": z.record(z.string(), z.number().int().min(0)),
  "daily_series": z.array(z.object({
    "date": z.string(),
    "passkey_logins": z.number().int().min(0),
    "fallback_logins": z.number().int().min(0),
    "new_passkeys": z.number().int().min(0)
  }))
});
